import React from 'react';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { AnyHierarchicalViewModel } from '../../../selectors/holisticViewModelSelector';
import { DirectoryCard } from './DirectoryCard';
import { LineCard } from './LineCard';
import { StationCard } from './StationCard';

export function HierarchicalViewModelCard(props: { model: AnyHierarchicalViewModel }) {
  switch (props.model.type) {
    case 'holistic':
      throw new Error('Unsupported attempt to render card for entire hierarchy, which is impossible.');

    case 'directory':
      return <DirectoryCard directory={props.model.source} />;

    case 'line':
      return <LineCard line={props.model.source} />;

    case 'station':
      return <StationCard station={props.model.source} />;

    default:
      assertExhaustiveSwitch(props.model);
  }
}
